import { debounce, find, some } from "lodash";
import everythingAbout from './tabs/everything-about/index.vue'
import description from './tabs/description/index.vue'
import structure from './tabs/description/index.vue'
import productPrice from './components/product-price/index.vue'
import productPriceNew from './components/product-price-new/index.vue'
import recommendation from './tabs/description/index.vue'
import comments from './tabs/comments/index.vue'
import comment from './components/comment-card/index.vue'
import questions from './tabs/questions/index.vue'
import slider from './components/slider/index.vue'
import product from '../../components/product/index.vue'
import accordion from './components/accordion/index.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import { getProductPriceTitle } from '@/helpers'
import StarRating from 'vue-star-rating'
import BlackFridayIcon from "@/components/@icons/BlackFridayIcon.vue";
import IconMagnifier from "@/components/@icons/IconMagnifier.vue";
import ProductGallery from "@/modules/card/components/gallery/index.vue";
import dynamicsHead from "@/mixins/dynamics-head";
import { VueSlideToggle } from 'vue-slide-toggle'
import ChevronTop from "@/components/@icons/ChevronTop.vue";
import DeliveryCar from "@/components/@icons/DeliveryCar.vue";
import Warranty from "@/components/@icons/Warranty.vue";

const CardTab = {
  EVERYTHING_ABOUT: 0,
  DESCRIPTION: 1,
  STRUCTURE: 2,
  RECOMMENDATION: 3,
  COMMENTS: 4,
  QUESTIONS: 5,
}

export default {
  name: 'card',
  components: {
    Warranty,
    DeliveryCar,
    ChevronTop,
    ProductGallery,
    IconMagnifier,
    BlackFridayIcon,
    StarRating,
    productPrice,
    everythingAbout,
    description,
    structure,
    recommendation,
    comment,
    comments,
    questions,
    slider,
    Carousel,
    Slide,
    product,
    accordion,
    productPriceNew,
    VueSlideToggle
  },
  data() {
    return {
      CardTab,
      clientPrices: [],
      sameProducts: [],
      tabs: [],
      currentTab: CardTab.DESCRIPTION,
      selectedCount: 1,
      selectedProductPrice: {},
      leftoverType: null,
      images: [],
      timeRemaining: null,
      timerInterval: null,
      showGallery: false,
      showDeliveryBlock: true,
      showDeliveryBlockTwo: true,
      showDeliveryBlockThree: true,
      showWarrantyBlock: true,
      showPaymentBlock: true,
    }
  },
  watch: {
    selectedProductPrice: function () {
      this.addImageProduct()
      this.stopTimer()
      this.startTimer()
      this.$nextTick(() => {
        this.setPageMetaInfo(this.product)
      })
    },
  },
  mounted() {
    this.startTimer()
  },
  beforeDestroy() {
    this.stopTimer()
  },
  async created() {
    this.tabs = [
      {
        id: CardTab.EVERYTHING_ABOUT,
        title: 'allAboutTheProduct',
      },
      {
        id: CardTab.DESCRIPTION,
        title: 'description',
      },
      {
        id: CardTab.STRUCTURE,
        title: 'warehouse',
      },
      {
        id: CardTab.RECOMMENDATION,
        title: 'recommendations',
      },
      {
        id: CardTab.COMMENTS,
        title: 'reviewsAndQuestions',
      },
      // {
      //   id: CardTab.QUESTIONS,
      //   title: "questionsAndAnswers",
      // }
    ]
    this.showGlobalLoader(true)
    await this.fetchProduct({
      slug: this.$route.params.slug,
      value: this.$route.query.value,
    })
    this.showGlobalLoader(false)
    this.setPageMetaInfo(this.product)
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: this.currentRegionCurrency || 'EUR',
        value: this.product.productPrices.data[0].price,
        items: [
          {
            item_id: this.product.productPrices.data[0].article,
            item_name: this.product.title,
            affiliation: 'Renew-Cosmetics',
            coupon: '',
            discount: 0.0,
            index: 0,
            item_brand: this.product?.brand?.data?.title || 'Renew',
            item_category: this.product?.brandSeries?.data?.title || 'Makeup removal',
            item_category2: (() => {
              if (!this.isAuthenticated) return 'unauthorized'
              if (this.isProfessional) return 'professional'
              if (this.isDistributor) return 'distributor'
              return 'regular'
            })(),
            item_list_id: 'Cosmetics',
            item_list_name: 'Cosmetics',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: Number(this.product.productPrices.data[0].price).toFixed(2),
            quantity: 1,
          },
        ],
      },
    })

    this.checkValue()

    await Promise.all([this.getProductPrice(), this.loadSameProducts()])
  },
  mixins: [dynamicsHead],
  computed: {
    ...mapGetters({
      productLoading: 'card/productLoading',
      product: 'card/product',
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional',
      isUserWithCode: 'profile/isUserWithCode',
      favourites: 'favorites/whichList',
      basket: 'basket/basket',
      productsWithDefaultPrices: 'basket/productsWithDefaultPrices',
      user: 'profile/user',
      isAuthenticated: 'auth/isAuthenticated',
      showNotifyLoader: 'products/showNotifyLoader',
      currentRegionCurrency: 'regions/currentRegionCurrency',
      globalLoader: 'system/globalLoader',
    }),
    galleryImages() {
      return this.images.map(item => item.link);
    },
    showBlackFriday() {
      const blackFridayEndDate = new Date('2025-12-31T23:59:59')
      const now = new Date()
      return now < blackFridayEndDate
    },
    windowSize() {
      return window.innerWidth
    },
    isOutlet() {
      return this.selectedProductPrice.outletReasons && this.selectedProductPrice.outletReasons.data && this.selectedProductPrice.outletReasons.data.length
    },
    canBePurchased() {
      return !(this.leftoverType.displayType === 'out-stock') && !this.product.hasDuplicate
    },
    isRefill(productPrice) {
      return productPrice.isRefill;
    },
    isWithoutBox(productPrice) {
      return productPrice.withoutBox;
    },
    /*unauthorised or authorised without code*/
    isRegularUser() {
      return !(this.isUserWithCode || this.isProfessional || this.isDistributor)
    },
    clientPriceTypeName() {
      return this.isProfessional ? this.$t('patient') : this.$t('cosmetologist')
    },
    hasSaleTimer() {
      return this.selectedProductPrice &&
             this.selectedProductPrice.saleActiveTo &&
             this.timeRemaining &&
             this.timeRemaining.total > 0 &&
             (this.timeRemaining.days > 0 || this.timeRemaining.hours > 0 || this.timeRemaining.minutes > 0 || this.timeRemaining.seconds > 0)
    },
  },
  methods: {
    getProductPriceTitle,
    ...mapActions({
      addToFavorite: 'favorites/ADD_PRODUCT_TO_FAVOURITES',
      fetchProduct: 'card/GET_PRODUCT',
      fetchProductByCount: 'card/GET_PRODUCT_BY_COUNT',
      fetchSameProduct: 'card/GET_SAME_PRODUCTS',
      removeFromFavorite: 'favorites/REMOVE_PRODUCT_IN_FAVORITE',
      getFavorites: 'favorites/GET_FAVORITES_LIST',
      fetchDefaultPrices: 'basket/GET_DEFAULT_PRICE_BASKET',
      fetchData: 'products/SET_PRODUCT_WHEN_AVAILABLE',
    }),
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      changeFastBuyPopup: 'popups/CHANGE_FAST_BUY_POPUP',
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      changeBasketPopup: 'popups/CHANGE_BASKET_POPUP',
      showNotifyWhenAvailable: 'popups/SHOW_NOTIFY_WHEN_AVAILABLE',
      changeSeminarDetailsPopup: 'popups/CHANGE_SEMINAR_DETAILS_POPUP',
      showGlobalLoader: 'system/SHOW_GLOBAL_LOADER',
      openLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      openAgentRegisterPopup: 'popups/CHANGE_AGENT_REGISTER_POPUP',
    }),
    openLogin() {
      this.openLoginPopup(true)
    },
    openProfessionalRegister() {
      this.openAgentRegisterPopup(true)
    },
    checkValue() {
      const productPrices = this.product.productPrices.data
      const productPrice = find(productPrices, (productPrice) => this.isSelectedPrice(productPrice))
      this.selectProductPrice(productPrice || productPrices[0])
    },
    handleGalleryClose() {
      this.showGallery = false;
    },
    showNotify() {
      const showPopup = () => {
        this.changeSeminarDetailsPopup({
          status: true,
          payload: {
            title: this.$t('thankYouForContactingUsAManagerWillContactYouSoonTitle'),
            detail: this.$t('thankYouForContactingUsAManagerWillContactYouSoon'),
          },
        })
      }

      const payload = {
        product_id: this.product.id,
        product_price_id: this.selectedProductPrice.id,
      }

      if (!this.isAuthenticated) {
        this.showNotifyWhenAvailable({ status: true, payload })
      } else {
        this.fetchData(payload).then(showPopup).catch(showPopup)
      }
    },
    async loadSameProducts() {
      this.sameProducts = await this.fetchSameProduct(this.$route.params.slug)
    },
    async getProductPrice() {
      let ids = [this.product.id]
      await this.fetchDefaultPrices({ ids: ids })

      this.productsWithDefaultPrices.forEach((product) => {
        this.clientPrices = product.productPrices.data
      })
    },
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      // if (!this.leftoverType) {
        this.leftoverType = productPrice.leftoverType.data
      // }

      this.selectedCount = Number(this.canBePurchased)

      this.selectedProductPrice = productPrice

      this.leftoverType = productPrice.leftoverType.data

      this.setSelectedCount(this.selectedCount, productPrice)
      if (productPrice.id === this.product.productPrices.data[0].id) {
        this.$router.replace({ query: null }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
        this.removeNoIndexNoFollow()
      } else {
        this.setPriceValueToQuery(productPrice.value);
        this.addNoIndexNoFollow()
      }
    },
    setPriceValueToQuery(value) {
      this.$router.replace({ query: { value } })
    },
    isSelectedPrice(productPrice) {
      return parseInt(this.selectedProductPrice.id) === parseInt(productPrice.id)
    },
    addImageProduct() {
      this.images = _(this.product.images.data)
        .toArray()
        .unshift({ link: this.selectedProductPrice.image })
        .filter(({ link }) => link)
        .uniqBy('link')
        .value()
    },

    checkProductInFavorites() {
      if (this.user) {
        const index = this.favourites.find((e) => e.productId === this.product.id)
        return !!index
      }
      return false
    },

    changeFavorite() {
      if (this.user) {
        const index = this.favourites.find((e) => e.productId === this.product.id)
        if (index) {
          this.removeFromFavorite(index.id).then(() => {
            this.getFavorites()
            this.favoriteSelect = false
            this.$toasted.success(this.$t('successRemoveFromFavorite'))
          })
        } else {
          this.addToFavorite({ product_id: this.product.id }).then(() => {
            this.favoriteSelect = true
            this.$toasted.success(this.$t('successAddToFavorites'))
            this.getFavorites()
          })
        }
      } else {
        this.changeLoginPopup(true)
      }
    },
    changeTab(val) {
      this.currentTab = val
    },
    openFastBuy() {
      this.changeFastBuyPopup(true, {
        product: {
          select_count: 1,
          select_type: this.selectedProductPrice,
          ...this.product,
        },
      })
    },
    changeCount(type, count) {
      // this.setSelectedCount(count)
      if (type === 'decrement' && this.selectedCount > 1) {
        return this.setSelectedCount(this.selectedCount - 1)
      } else if (type === 'increment') {
        return this.setSelectedCount(this.selectedCount + 1)
      } else {
        return this.setSelectedCount(count)
      }
    },
    async setSelectedCount(count, productPrice = null) {
      const newCount = Math.min(Math.max(Number.parseFloat(count || '1'), 1), (productPrice || this.selectedProductPrice).quantity)

      try {
        this.updateProductPrices(newCount)
      } catch (error) {
        console.log('Ignored error: ', error);
      }
      // this.selectedCount = 0
      return (this.selectedCount = Math.ceil(newCount))
    },

    updateProductPrices: debounce(async function (count) {
      await this.fetchProductByCount({
        slug: this.$route.params.slug,
        value: this.$route.query.value,
        count: count,
      });
    }, 300),

    carouselNav($event, direction) {
      const carousel = this.$refs['card-carousel']
      carousel.advancePage(direction)
    },
    addBasket() {
      this.addToBasket({
        select_count: this.selectedCount,
        product_price: this.selectedProductPrice,
        product: this.product,
      })
      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: this.currentRegionCurrency || 'EUR',
          value: this.selectedProductPrice.price,
          items: [
            {
              item_id: this.selectedProductPrice.article,
              item_name: this.product.title,
              affiliation: 'Renew-Cosmetics',
              coupon: '',
              discount: 0.0,
              index: 0,
              item_brand: this.product?.brand?.data?.title || 'Renew',
              item_category: this.product?.brandSeries?.data?.title || 'Makeup removal',
              item_category2: (() => {
                if (!this.isAuthenticated) return 'unauthorized'
                if (this.isProfessional) return 'professional'
                if (this.isDistributor) return 'distributor'
                return 'regular'
              })(),
              item_list_id: 'Cosmetics',
              item_list_name: 'Cosmetics',
              location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
              price: Number(this.selectedProductPrice.price).toFixed(2),
              quantity: 1,
            },
          ],
        },
      })

      this.changeBasketPopup(true)
      this.$toasted.success(this.$t('successAddBasket'))
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getBasePriceForUser(productPrice) {
      if (this.isUserWithCode) {
        const clientProductPrice = find(this.clientPrices, (price) => price.value === productPrice.value)

        if (!clientProductPrice) {
          return '0'
        }

        return clientProductPrice.price.toFixed(0)
      }

      if (this.priceHasDiscountForProfessional(productPrice)) {
        return productPrice.oldPrice.toFixed(0)
      }

      return '0'
    },
    showClientPriceColumn() {
      /*todo - isDistributor*/
      return (this.isProfessional || this.isDistributor) && some(this.clientPrices, ({ typeVisible }) => typeVisible)
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {boolean}
     */
    showClientPrice(productPrice) {
      /*todo - isDistributor*/
      return (
        (this.isProfessional || this.isDistributor) &&
        some(this.clientPrices, (clientPrice) => clientPrice.value === productPrice.value && clientPrice.typeVisible)
      )
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getClientPrice(productPrice) {
      return (productPrice.clientPrice && productPrice.clientPrice !== 0 ? productPrice.clientPrice : productPrice.price)?.toFixed(0)
    },
    productHasDiscountForSomePrice() {
      if (this.isProfessional || this.isDistributor) {
        return some(
          this.product.productPrices.data,
          (productPrice) => productPrice.hasIndividualDiscount || productPrice.hasActivePromotion
        )
      }

      return some(this.product.productPrices.data, (productPrice) => productPrice.hasActivePromotion)
    },
    /**
     * @param {ProductPrice} productPrice
     * @return {boolean}
     */
    priceHasDiscountForProfessional(productPrice) {
      /*todo - isDistributor*/
      if (!(this.isProfessional || this.isDistributor)) {
        return false
      }

      return productPrice.hasIndividualDiscount || productPrice.hasActivePromotion
    },
    professionalHasDiscount() {
      return (this.isProfessional || this.isDistributor) && this.productHasDiscountForSomePrice()
    },
    calculateTimeRemaining() {
      if (!this.selectedProductPrice || !this.selectedProductPrice.saleActiveTo) {
        this.timeRemaining = null
        return
      }

      const endDate = new Date(this.selectedProductPrice.saleActiveTo)
      const now = new Date()
      const total = endDate - now

      if (total <= 0) {
        this.timeRemaining = {
          total: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        }
        this.stopTimer()
        return
      }

      const seconds = Math.floor((total / 1000) % 60)
      const minutes = Math.floor((total / 1000 / 60) % 60)
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
      const days = Math.floor(total / (1000 * 60 * 60 * 24))

      this.timeRemaining = {
        total,
        days,
        hours,
        minutes,
        seconds,
      }
    },
    startTimer() {
      this.calculateTimeRemaining()
      if (this.timeRemaining && this.timeRemaining.total > 0) {
        this.timerInterval = setInterval(() => {
          this.calculateTimeRemaining()
        }, 1000)
      }
    },
    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
  },
}
